import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the scroll position to the top whenever the React-Router pathname
 * changes. SPAs don't trigger a fresh page load on internal navigation, so
 * the browser keeps the previous scroll offset (which is why links from the
 * footer landed users at the bottom of the next page).
 *
 * Mounted once inside <BrowserRouter> in App.js.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Skip auto-scroll for hash links (#section) so deep-anchors still work.
    if (window.location.hash) return;
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
